import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { RoleService } from '~/app/core/services';

@Component({
  selector: 'app-company-tab',
  templateUrl: './company-tab.component.html',
  styleUrls: ['./company-tab.component.scss']
})
export class CompanyTabComponent implements OnInit {
  tabs = [];
  regulatory_filing_active = false;
  moduleId;
  constructor(
    private roleService: RoleService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.regulatory_filing_active = event.url.indexOf('transactions/detail') !== -1 ? true : false;
      }
    })
   }

  ngOnInit(): void {
    this.tabs = this.route.snapshot.data.tabs;
    for (const tab of this.tabs) {
      tab.access = this.roleService.accessFeature(tab.feature_id);
      if (this.route.children.length === 0 && tab.access) {
        this.router.navigate([this.router.url, tab.link]);
      }
    }
  }
}
